
<p *ngIf="wrongInput" [innerHTML]="wrongInput"></p>
<!-- <p *ngIf="item.stav" [innerHTML]="item.stav"></p> -->
<!-- <p>{{item.stav}}</p> -->

<div *ngFor="let item of udaje">
  <p *ngIf="item.Zasielka_Kod === null">{{lang.noData1}}<br>{{lang.noData2}}</p>
</div>

<div *ngFor="let item of udaje; first as isFirst">
    <span *ngIf="isFirst">
      <table style="width:100%">
        <tbody>
          <tr *ngIf="item.Zasielka_Kod">
            <td>{{lang.shipmentNumber}}:</td>
            <td>{{item.Zasielka_Kod}}</td>
          </tr>
          <tr *ngIf="item.PoznamkaKlient">
            <td>{{lang.noteClient}}:</td>
            <td>{{item.PoznamkaKlient}}</td>
          </tr>
          <tr *ngIf="item.DatumObjed">
            <td>{{lang.dateOrder}}:</td>
            <td>{{item.DatumObjed | date:'d. M. YYYY HH:mm'}}</td>
          </tr>
          <tr *ngIf="item.hlavnyStatus">
            <td>{{lang.currentStatus}}:</td>
            <td>{{item.hlavnyStatus}} - {{item.detailnyStatus}}</td>
          </tr>
          <tr *ngIf="item.DatumPrevz">
            <td>{{lang.onDeliveryFrom}}:</td>
            <td>{{item.DatumPrevz | date:'d. M. YYYY HH:mm'}}</td>
          </tr>
          <!-- <tr *ngIf="item.DateEstimatedDelivery">
            <td>Predpokladané doručenie:</td>
            <td>(cca.) {{item.DateEstimatedDelivery | date:'d. M. YYYY HH:mm'}}</td>
          </tr> -->
          <tr *ngIf="item.DatumDoruc">
            <td>{{lang.delivered}}:</td>
            <td>{{item.DatumDoruc | date:'d. M. YYYY HH:mm'}}</td>
          </tr>
          <tr *ngIf="item.KontaktDoruc">
            <td>{{lang.whoTook}}:</td>
            <td>{{item.KontaktDoruc}}</td>
          </tr>
        </tbody>
      </table>

      <table *ngIf="item.kedyNedorucena" style="margin:10px 0px 0px 0px;">
        <caption>{{lang.previousDelivery}}</caption>
        <tr>
          <th>{{lang.previousDeliveryDate}}</th>
          <th>{{lang.previousDeliveryReason}}</th>
        </tr>
        <tbody>
          <tr *ngFor="let nedorucena of item.kedyNedorucena; first as isFirst">
            <td>{{nedorucena.Datum | date:'d. M. YYYY HH:mm'}}</td>
            <td>{{nedorucena.detailnyStatus}}</td>
          </tr>
        </tbody>
      </table>
    </span>
  </div>